import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UploadImageComponent } from 'src/app/dashboard/upload-image/upload-image.component';

declare const google: any;
declare const $: any;
@Component({
  selector: 'location-selector',
  templateUrl: './location-selector.component.html',
  styleUrls: ['./location-selector.component.scss']
})
export class LocationSelectorComponent implements OnInit {

  @Input() coordinate: any = { lat: 0, long: 0 };
  @Output() coordinateChange: EventEmitter<any> = new EventEmitter();
  @ViewChild("selector") locationSelector: TemplateRef<any>;

  constructor(
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {


  }

  selectedCoordinate = { lat: 0, long: 0 };

  initializeMap() {
    let map;
    let marker;
    const myLatlng = new google.maps.LatLng(this.coordinate.lat, this.coordinate.long);

    const myOptions = {
      zoom: 16,
      center: myLatlng,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };
    map = new google.maps.Map(document.getElementById("map-canvas"), myOptions);

    marker = new google.maps.Marker({
      draggable: true,
      position: myLatlng,
      map: map,
      title: "Your location"
    });



    const getCurrentCoordinate = (event) => {
      console.log({ event })
      if (event) {
        const selectedCoordinate = {
          lat: event.latLng.lat(),
          long: event.latLng.lng()
        };

        $('#coordinate-event-transport').get(0).dispatchEvent(new CustomEvent('setSelectedCoordinate', {
          detail: {
            selectedCoordinate
          }
        }))
        console.log('Location OnClick', selectedCoordinate)
        marker.setPosition(event.latLng);
      }
    }

    google.maps.event.addListener(marker, 'dragend', getCurrentCoordinate);
    google.maps.event.addListener(map, 'click', getCurrentCoordinate);
  }

  handleCoordinateChange(e) {
    this.selectedCoordinate = e.detail.selectedCoordinate
  }

  modalRef
  openLocationSelector() {
    this.modalRef = this.modalService.open(this.locationSelector, { size: 'lg', backdrop: 'static' });
    this.initializeMap()

    this.modalRef.result.then((result) => {
      console.log(result);
      if (result !== false) {
        this.coordinate = this.selectedCoordinate;
        this.coordinateChange.emit(this.coordinate);
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  selectLocation(e) {
    this.modalRef.close(true);

  }
  cancelSelectLocation(e) {
    this.modalRef.close(false);
  }



}